import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-not-logged-header',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './not-logged-header.component.html',
  styleUrl: './not-logged-header.component.scss'
})
export class NotLoggedHeaderComponent {

}
